(function () {
  'use strict';

  const state = {
    gender: 'men',
    hand: null,
    size: null,
    fit: null,
    productId: null,
    sellingPlanIndex: 1,
    caseVariantId: null,
  };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  function setActive(group, clicked) {
    qsa('.dgc-selector-btn', group).forEach(b => b.classList.remove('is-active'));
    clicked.classList.add('is-active');
  }

  function titleCase(value) {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function normalizeToken(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function localizedPath(path) {
    const root = (window.routes && (window.routes.root_url || window.routes.root))
      || (window.Shopify && Shopify.routes && Shopify.routes.root)
      || '/';
    const cleanRoot = root === '/' ? '' : String(root).replace(/\/$/, '');
    return cleanRoot + path;
  }

  function syncGenderButtons(gender) {
    genderBtns.forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.gender === gender);
    });
  }

  function parseVariantParts(inp) {
    const handle = normalizeToken(inp.value.split('/')[0]);
    const parts = handle.split('-').filter(Boolean);
    const joined = parts.join('-');
    const sizes = ['xxl', 'xl', 'ml', 'l', 'm', 's'];

    let hand = null;
    if (joined.includes('left-hand') || joined.includes('main-gauche') || parts.includes('left') || parts.includes('gauche')) {
      hand = 'left';
    } else if (joined.includes('right-hand') || joined.includes('main-droite') || parts.includes('right') || parts.includes('droite')) {
      hand = 'right';
    }

    const size = sizes.find(sizeValue => parts.includes(sizeValue)) || null;
    let fit = null;
    if (parts.includes('regular') || parts.includes('regulier') || parts.includes('reguliere')) {
      fit = 'regular';
    } else if (parts.includes('cadet')) {
      fit = 'cadet';
    }

    return {
      hand: hand || parts[0] || null,
      size: size || parts[1] || null,
      fit: fit || parts[2] || null,
    };
  }

  function matchesCurrentSelection(parts, overrides) {
    const selection = overrides || {};
    const hand = selection.hand !== undefined ? selection.hand : state.hand;
    const size = selection.size !== undefined ? selection.size : state.size;
    const fit = selection.fit !== undefined ? selection.fit : state.fit;

    if (hand && parts.hand !== normalizeToken(hand)) return false;
    if (size && parts.size !== normalizeToken(size)) return false;
    if (state.gender === 'men' && fit && parts.fit !== normalizeToken(fit)) return false;
    return true;
  }

  function getProductDataElById(productId) {
    return qs('.dgc-product-data[data-product-id="' + productId + '"]');
  }

  function getAvailableVariants(productDataEl) {
    if (!productDataEl) return [];
    return qsa('input.dgc-hidden-variant', productDataEl)
      .filter(inp => !inp.classList.contains('not-available'));
  }

  function getVariantPool() {
    if (state.productId) {
      return getAvailableVariants(getProductDataElById(state.productId));
    }

    const variants = [];
    const visibleCards = qsa('.dgc-glove-tab[data-gender="' + state.gender + '"] .dgc-glove-card');

    visibleCards.forEach(card => {
      getAvailableVariants(getProductDataElById(card.dataset.productId)).forEach(variant => {
        variants.push(variant);
      });
    });

    if (!variants.length) {
      qsa('.dgc-product-data .dgc-hidden-variant').forEach(variant => {
        if (!variant.classList.contains('not-available')) {
          variants.push(variant);
        }
      });
    }

    return variants;
  }

  function updateGloveAvailability() {
    const visibleCards = qsa('.dgc-glove-tab[data-gender="' + state.gender + '"] .dgc-glove-card');

    visibleCards.forEach(card => {
      const variants = getAvailableVariants(getProductDataElById(card.dataset.productId));
      const isAvailable = variants.some(inp => matchesCurrentSelection(parseVariantParts(inp)));

      card.classList.toggle('is-unavailable', !isAvailable);
      card.setAttribute('aria-disabled', String(!isAvailable));
      card.setAttribute('aria-pressed', String(card.classList.contains('is-active')));
      if (!isAvailable && card.classList.contains('is-active')) {
        card.classList.remove('is-active');
        state.productId = null;
        card.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateTimeframeAccessibility() {
    qsa('.dgc-timeframe-card').forEach((card, idx) => {
      card.setAttribute('aria-pressed', String(idx === state.sellingPlanIndex));
    });
  }

  function updateOptionAvailability() {
    const variants = getVariantPool();

    qsa('.dgc-selector-btn[data-option="hand"]').forEach(btn => {
      const val = btn.dataset.value.toLowerCase();
      const avail = variants.some(inp => {
        const parts = parseVariantParts(inp);
        return matchesCurrentSelection(parts, { hand: val });
      });
      btn.disabled = !avail;
      btn.classList.toggle('is-unavailable', !avail);
      if (!avail && btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        state.hand = null;
      }
    });

    qsa('.dgc-selector-btn[data-option="size"]').forEach(btn => {
      const val = btn.dataset.value.toLowerCase();
      const avail = variants.some(inp => {
        const parts = parseVariantParts(inp);
        return matchesCurrentSelection(parts, { size: val });
      });
      btn.disabled = !avail;
      btn.classList.toggle('is-unavailable', !avail);
      if (!avail && btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        state.size = null;
      }
    });

    qsa('.dgc-selector-btn[data-option="fit"]').forEach(btn => {
      const val = btn.dataset.value.toLowerCase();
      const avail = variants.some(inp => {
        const parts = parseVariantParts(inp);
        return matchesCurrentSelection(parts, { fit: val });
      });
      btn.disabled = !avail;
      btn.classList.toggle('is-unavailable', !avail);
      if (!avail && btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        state.fit = null;
      }
    });

    updateGloveAvailability();
  }

  const genderBtns = qsa('.dgc-gender-btn');
  const menTab = qs('.dgc-glove-tab[data-gender="men"]');
  const womenTab = qs('.dgc-glove-tab[data-gender="women"]');
  const fitGroup = qs('.dgc-plan__fit-group');

  function switchGender(gender) {
    state.gender = gender;
    state.productId = null;
    state.hand = null;
    state.size = null;
    state.fit = null;
    syncGenderButtons(gender);

    if (menTab) menTab.hidden = (gender !== 'men');
    if (womenTab) womenTab.hidden = (gender !== 'women');

    if (fitGroup) {
      fitGroup.classList.toggle('is-visible', gender === 'men');
    }

    qsa('.dgc-selector-btn[data-option]').forEach(b => b.classList.remove('is-active'));

    qsa('.dgc-glove-card').forEach(c => {
      c.classList.remove('is-active');
      c.setAttribute('aria-pressed', 'false');
    });

    updateOptionAvailability();
    updateCheckoutBtn();
    updateErrorMessage();
  }

  genderBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const nextGender = btn.dataset.gender;
      if (state.gender === nextGender) return;

      setActive(btn.closest('.dgc-plan__selector-btns'), btn);
      switchGender(nextGender);
    });
  });

  qsa('.dgc-selector-btn[data-option]').forEach(btn => {
    btn.addEventListener('click', () => {
      const option = btn.dataset.option;
      const group = btn.closest('.dgc-plan__selector-btns');
      if (btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        state[option] = null;
        btn.blur();
      } else {
        setActive(group, btn);
        state[option] = btn.dataset.value;
      }
      updateOptionAvailability();
      updateCheckoutBtn();
      updateErrorMessage();
    });
  });

  qsa('.dgc-glove-card').forEach(card => {
    card.addEventListener('click', () => {
      const tab = card.closest('.dgc-glove-tab');
      if (tab && tab.hidden) return;
      if (card.classList.contains('is-unavailable')) return;

      if (card.classList.contains('is-active')) {
        card.classList.remove('is-active');
        state.productId = null;
        card.setAttribute('aria-pressed', 'false');
      } else {
        qsa('.dgc-glove-card').forEach(c => {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-active');
        state.productId = card.dataset.productId;
        card.setAttribute('aria-pressed', 'true');
      }
      updateOptionAvailability();
      updateCheckoutBtn();
      updateErrorMessage();
    });
  });

  qsa('.dgc-timeframe-card').forEach((card, idx) => {
    card.addEventListener('click', () => {
      qsa('.dgc-timeframe-card').forEach(c => c.classList.remove('is-active'));
      card.classList.add('is-active');
      state.sellingPlanIndex = idx;
      updateTimeframeAccessibility();
      updateCheckoutBtn();
    });
  });

  qsa('.dgc-case-card__add-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.dataset.variantId;
      if (state.caseVariantId === variantId) {
        state.caseVariantId = null;
        btn.textContent = 'Add +';
        btn.classList.remove('is-added');
      } else {
        qsa('.dgc-case-card__add-btn').forEach(b => {
          b.textContent = 'Add +';
          b.classList.remove('is-added');
        });
        state.caseVariantId = variantId;
        btn.textContent = 'Added';
        btn.classList.add('is-added');
      }
    });
  });

  const checkoutBtn = qs('.dgc-plan__checkout-btn');
  const errorEl = qs('.dgc-plan__error');
  let isSubmitting = false;

  function resetCheckoutBtn() {
    if (!checkoutBtn) return;
    isSubmitting = false;
    checkoutBtn.disabled = false;
    checkoutBtn.classList.toggle('is-disabled', !isReady());
    checkoutBtn.textContent = checkoutBtn.dataset.label || 'Go To Checkout';
  }

  function withTimeout(promise, ms, message) {
    return Promise.race([
      promise,
      new Promise((_, reject) => {
        window.setTimeout(() => reject(new Error(message)), ms);
      }),
    ]);
  }

  function isReady() {
    if (!state.gender) return false;
    if (!state.hand) return false;
    if (!state.size) return false;
    if (state.gender === 'men' && !state.fit) return false;
    if (!state.productId) return false;
    return true;
  }

  function updateCheckoutBtn() {
    if (!checkoutBtn) return;
    checkoutBtn.disabled = isSubmitting;
    checkoutBtn.classList.toggle('is-disabled', !isSubmitting && !isReady());
  }

  function updateErrorMessage() {
    if (!errorEl || !errorEl.classList.contains('is-visible')) return;
    const missing = getMissingSelections();
    if (!missing.length) {
      errorEl.classList.remove('is-visible');
    } else {
      errorEl.textContent = 'Please select your ' + formatMissingSelections(missing) + ' to proceed to checkout.';
    }
  }

  function getMissingSelections() {
    const missing = [];
    if (!state.hand) missing.push('hand');
    if (!state.size) missing.push('size');
    if (state.gender === 'men' && !state.fit) missing.push('fit');
    if (!state.productId) missing.push('glove style');
    return missing;
  }

  function formatMissingSelections(missing) {
    if (!missing.length) return '';
    if (missing.length === 1) return missing[0];
    if (missing.length === 2) return missing[0] + ' and ' + missing[1];
    return missing.slice(0, -1).join(', ') + ', and ' + missing[missing.length - 1];
  }

  function getProductDataEl() {
    return getProductDataElById(state.productId);
  }

  function findSelectedVariantInput(productDataEl) {
    return qsa('input.dgc-hidden-variant', productDataEl).find(inp => {
      if (inp.classList.contains('not-available')) return false;
      return matchesCurrentSelection(parseVariantParts(inp));
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async () => {
      if (isSubmitting) return;
      if (!isReady()) {
        if (errorEl) {
          const missing = getMissingSelections();
          errorEl.textContent = 'Please select your ' + formatMissingSelections(missing) + ' to proceed to checkout.';
          errorEl.classList.add('is-visible');
        }
        return;
      }
      if (errorEl) errorEl.classList.remove('is-visible');

      const productDataEl = getProductDataEl();
      if (!productDataEl) return;

      const variantInput = findSelectedVariantInput(productDataEl);

      if (!variantInput || variantInput.classList.contains('not-available')) {
        if (errorEl) {
          errorEl.textContent = 'This combination is currently unavailable.';
          errorEl.classList.add('is-visible');
        }
        return;
      }

      const variantId = Number(variantInput.value.split('/').pop());
      const sellingPlansRaw = variantInput.dataset.sellingPlans || '';
      const sellingPlanArr = sellingPlansRaw.split(',').filter(Boolean);
      const sellingPlan = Number(sellingPlanArr[state.sellingPlanIndex] || sellingPlanArr[0] || 0);

      isSubmitting = true;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Processing...';

      try {
        const items = [];
        if (variantId) {
          const mainItem = { id: variantId, quantity: 1 };
          if (sellingPlan) mainItem.selling_plan = sellingPlan;
          items.push(mainItem);
        }
        if (state.caseVariantId) {
          items.push({ id: Number(state.caseVariantId), quantity: 1 });
        }

        if (items.length) {
          if (window.RRGCart && typeof window.RRGCart.addItems === 'function') {
            await withTimeout(
              window.RRGCart.addItems(items, { sections: false, openDrawer: false }),
              12000,
              'Timed out while adding the items to the cart.'
            );
          } else {
            throw new Error('Cart helper is unavailable.');
          }
        }

        const cartResponse = await withTimeout(
          fetch(localizedPath('/cart.js')),
          12000,
          'Timed out while loading the cart.'
        );
        if (!cartResponse.ok) {
          throw new Error('Unable to verify the cart before checkout.');
        }
        const cart = await cartResponse.json();
        sessionStorage.setItem('bundleToken', cart.token);
        window.location.assign(localizedPath('/checkout'));
      } catch (e) {
        console.error('[DGC] checkout error', e);
        if (errorEl) {
          errorEl.textContent = e.message || 'There was an issue starting checkout. Please try again.';
          errorEl.classList.add('is-visible');
        }
        resetCheckoutBtn();
      }
    });
  }

  window.addEventListener('pageshow', (e) => {
    if (e.persisted) resetCheckoutBtn();
  });

  qsa('a[href="#pick-your-plan"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = qs('#pick-your-plan');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  const defaultTimeframe = qs('.dgc-timeframe-card[data-default]');
  if (defaultTimeframe) defaultTimeframe.click();
  else {
    const first = qs('.dgc-timeframe-card');
    if (first) {
      first.classList.add('is-active');
      updateTimeframeAccessibility();
    }
  }

  syncGenderButtons('men');
  switchGender('men');
  if (womenTab) womenTab.hidden = true;
  if (fitGroup) fitGroup.classList.add('is-visible');
  updateTimeframeAccessibility();
})();
